import { Stack, Typography } from '@mui/material'
import React from 'react'

import { SalesOfficeAvatarPlaceholderIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/SalesOfficeAvatarPlaceholderIcon'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useSalesOfficeData } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/useSalesOfficeData'

const DefaultContact = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack direction='row' spacing={2}>
      <SalesOfficeAvatarPlaceholderIcon />
      <Stack justifyContent='space-evenly'>
        <Stack direction='column' justifyContent='flex-start' spacing={1}>
          <Typography variant='body2'>
            {t('houseDetailPage.vendor.find-your-contact-now')}
          </Typography>
          {children}
        </Stack>
      </Stack>
    </Stack>
  )
}

interface SalesOfficeProps {
  postcode: string
  vendorNid: string
  children: React.ReactNode
}

export const SalesOfficeForVendor = ({
  postcode,
  vendorNid,
  children
}: SalesOfficeProps) => {
  const { data: salesOffice } = useSalesOfficeData(vendorNid, postcode)

  const salesAgent = salesOffice?.faces[0]

  return (
    <>
      {salesAgent ? (
        <Stack direction='row' spacing={2}>
          {salesAgent.avatar ? (
            <img
              src={salesAgent.avatar}
              alt='consultant-photo'
              width={72}
              height={72}
            />
          ) : (
            <SalesOfficeAvatarPlaceholderIcon />
          )}
          <Stack justifyContent='space-between'>
            <Stack direction='row' justifyContent='flex-start' flexWrap='wrap'>
              <Typography variant='body2' marginRight={1}>
                {t('houseDetailPage.vendor.your-contact-at-vendor')}
              </Typography>
              {children}
            </Stack>
            <Typography fontWeight='fontWeightBold' variant='body2'>
              {`${salesAgent.first_name} ${salesAgent.last_name}`}
            </Typography>
            <Typography variant='body2'>{salesOffice?.city}</Typography>
          </Stack>
        </Stack>
      ) : (
        <DefaultContact>{children}</DefaultContact>
      )}
    </>
  )
}

SalesOfficeForVendor.DefaultContact = DefaultContact
